import { render, staticRenderFns } from "./search-form-item-button.vue?vue&type=template&id=4929d359&scoped=true"
import script from "./search-form-item-button.vue?vue&type=script&lang=js"
export * from "./search-form-item-button.vue?vue&type=script&lang=js"
import style0 from "./search-form-item-button.vue?vue&type=style&index=0&id=4929d359&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4929d359",
  null
  
)

export default component.exports